import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';

import { LayerEditService } from '@connect-services/client/services/layer-edit.service';
import { RessourcesModule } from '@ressources/client/ressources.module';

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [RessourcesModule],
    selector: 'app-edit-layer-bookmarked-attributes',
    styleUrl: './edit-layer-bookmarked-attributes.component.scss',
    templateUrl: './edit-layer-bookmarked-attributes.component.html',
})
export class EditLayerBookmarkedAttributesComponent {
    public changeOrder = output<number | null>();
    public readonly column = input.required<string>();
    public readonly hasError = input.required<boolean>();
    public readonly isBookmarked = input<boolean>(false);
    public readonly order = input<number | null>(null);
    public toggleIsBookmarked = output<void>();

    protected readonly max = LayerEditService.maxRange;
    protected readonly min = LayerEditService.minRange;
}
